<script setup lang="ts">
import { computed } from 'vue'
import { cx } from './cx'

const props = defineProps<{
  label: string
  value: number | string
  unit?: string
  tone?: 'accent' | 'ok' | 'default'
}>()

const color = computed(() =>
  props.tone === 'accent' ? 'text-accent-dim' : props.tone === 'ok' ? 'text-ok' : 'text-text',
)

const glow = computed(() =>
  props.tone === 'accent'
    ? 'radial-gradient(circle, rgb(0 194 168 / 0.35), transparent 70%)'
    : 'radial-gradient(circle, rgb(11 18 32 / 0.06), transparent 70%)',
)
</script>

<template>
  <div class="panel relative overflow-hidden px-5 py-4">
    <div
      class="pointer-events-none absolute -right-6 -top-6 size-20 rounded-full opacity-40"
      :style="{ background: glow }"
    />
    <p class="col-head relative">{{ label }}</p>
    <p :class="cx('relative mt-2 flex items-baseline gap-1.5', color)">
      <span class="tnum text-[28px] font-semibold tracking-tight">{{ value }}</span>
      <span v-if="unit" class="text-dim text-[12px] font-medium">{{ unit }}</span>
    </p>
  </div>
</template>
